import { World, WorldName, WorldNameValues } from './worlds/world';
import { testWorld } from './worlds/test';
import { shipwreckWorld } from './worlds/shipwreck';
import { jungleWorld } from './worlds/jungle';
import { caveWorld } from './worlds/cave';

const worldsInOrder = [WorldName.Shipwreck, WorldName.Jungle, WorldName.Cave];
const worldsLookup = {
  [WorldName.Test]: testWorld,
  [WorldName.Shipwreck]: shipwreckWorld,
  [WorldName.Jungle]: jungleWorld,
  [WorldName.Cave]: caveWorld
};

const worldIdToDeathEffectLookup = {
  [WorldName.Test]: 'water',
  [WorldName.Shipwreck]: 'water',
  [WorldName.Jungle]: 'leaves',
  [WorldName.Cave]: 'lava'
};

const worldIdToDeathEffectAudioLookup = {
  [WorldName.Test]: 'SndDieWater',
  [WorldName.Shipwreck]: 'SndDieWater',
  [WorldName.Jungle]: 'SndDieTree',
  [WorldName.Cave]: 'SndDieLava'
};

export const getWorldFromId = (worldId: WorldNameValues) => {
  if (worldsLookup[worldId] != undefined) return worldsLookup[worldId];
  else return getNextWorld();
};

export const getNextWorld = (oldWorld?: World): World => {
  if (oldWorld == undefined || oldWorld.id == WorldName.Test) return worldsLookup[worldsInOrder[0]];

  let index = worldsInOrder.indexOf(oldWorld.id);

  if (index == -1) return oldWorld;
  else return worldsLookup[worldsInOrder[(index + 1) % worldsInOrder.length]];
};

export const getDeathEffectFromWorld = (worldId: WorldNameValues): string => {
  return worldIdToDeathEffectLookup[worldId];
};

export const getDeathEffectAudioFromWorld = (worldId: WorldNameValues): string => {
  return worldIdToDeathEffectAudioLookup[worldId];
};
